/**
* @Author: zachalam
* @Date:   2017-01-09T14:53:09-08:00
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-13T12:55:13-07:00
*/



import React, { Component } from 'react';
import AutoCompleteInput from '../../common/AutoCompleteInput';
import { css, StyleSheet } from 'aphrodite/no-important';
import { textInput } from '../../../style';
import Container from '../../blocks/Container';
import Header from '../../blocks/Header';
import InputGroup from '../../blocks/InputGroup';
import Headline from '../../common/Headline';
import LongText from '../../common/LongText';
import Checkbox from '../../common/Checkbox';
import Panel from '../../common/Panel';
import RadioButtonSet from '../../common/RadioButtonSet';
import RadioButton from '../../common/RadioButton';
import Button from '../../blocks/Button';
import ButtonSet from '../../blocks/ButtonSet';
import DatePicker from 'react-datepicker';
import TagsInput from '../../common/TagsInput';
import moment from 'moment';
import { extractLocationData, geocodeByPlaceId, geocodeByAddress } from '../../../common';

require('react-datepicker/dist/react-datepicker.css');


const style = StyleSheet.create({
  textInput,

  inline: {
    width: 120,
  }
});

class TripCreate extends Component {

  constructor(props) {
    super(props);
    this.state = {
      address: '',
      who_pays: 2,
      description: '',
      country: '',
      region: '',
      city: '',
      zip: '',
      latitude: '',
      longitude: '',
      leaving_dt: moment()._d,
      leaving: moment(),
      returning_dt: moment().add(7,'d')._d,
      returning: moment().add(7,'d'),
      minReturningDate: moment(),    //minimum returningDate
      flexible_dates: false,
      tags: null
    }

    this.handleSubmit = this.handleSubmit.bind(this);
    this.locationSelectHandler = this.locationSelectHandler.bind(this);
    this.inputOnChange = this.inputOnChange.bind(this);
    this.onLeaveSelected = this.onLeaveSelected.bind(this);
    this.onReturnSelected = this.onReturnSelected.bind(this);
    this.onDescriptionSet = this.onDescriptionSet.bind(this);
    this.onWhosPayingSet = this.onWhosPayingSet.bind(this);
    this.onCheckboxChangeHandler = this.onCheckboxChangeHandler.bind(this);
    this.onTagChange = this.onTagChange.bind(this);
  }

  componentWillMount() {
    const {
      city,
      region,
      country
    } = this.props.location.query;

    if( city && (region || country) ) {
      const address = `${city}, ${region}, ${country}`;

      geocodeByAddress(city, region, country)
        .then((results) => {
          let loc = results[0];
          let locationData = Object.assign({}, extractLocationData(loc), { address })
          
          if(loc.geometry) {
            this.setState(locationData);
          }
          
        }).catch((error) => {
          console.error('Issue with Geocoding: ', error);
        })
    } else {
      return;
    }
  }

  handleSubmit(e) {
    //submit
    e.preventDefault();
    this.props.createNewTrip(this.state);
  }

  locationSelectHandler(address, placeId) {

    geocodeByPlaceId(placeId)
      .then((results) => {
        let loc = results[0];
        let placeData = extractLocationData(loc);
        let locText = `${placeData.city ? placeData.city + ', ' : ''}` +
          `${placeData.region ? placeData.region + ', ' : ''}` +
          `${placeData.country ? placeData.country : ''}`;
        
          let locationData = Object.assign({}, placeData, {address: locText});

        if(loc.geometry) {
          this.setState({...locationData, 'address': loc.formatted_address});
        }
      })
      .catch((error) => {
        console.error('Issue with Geocoding: ', error);
      });
  }

  inputOnChange(value) {
    this.setState({ address: value });
  }

  onLeaveSelected(date) {
    // set leaving object, datetime, and new minReturningDate
    this.setState({
      'leaving': date,
      'leaving_dt': date._d,
      'minReturningDate': date
    }, () => {
      // change returning date if in future.
      if(date > this.state.returning)
      this.setState({'returning': date});
    });

    // change returning date if in future


  }
  onReturnSelected(date) {
    this.setState({'returning': date, 'returning_dt': date._d});
  }

  onDescriptionSet(e) {
    this.setState({'description': e.target.value});
  }

  onWhosPayingSet(e) {
    this.setState({'who_pays': Number(e.target.value)});
  }

  onCheckboxChangeHandler(e) {
    // update checkbox
    let newState = Object.assign({},this.state);
    newState[e.target.id] = !newState[e.target.id];
    this.setState(newState);
  }

  onTagChange(items) {
    const tags = items.map((wrapper) => wrapper.item.tag)

    this.setState({ tags })
  }

  render() {
    const inputProps = {
      value: this.state.address || '',
      id: 'autocompleteLocation',
      placeholder: 'Enter a Location',
      type: 'text',
      className: ['textInput u-sizeFull'],
      onChange: this.inputOnChange
    }

    return (
      <div>
        <Container padding='large' screenTop width='medium'>
          <Panel withHeader>
            <Header>
              <Headline>Create a trip</Headline>
            </Header>
            <form onSubmit={this.handleSubmit}>
                <InputGroup inputLabel="Traveling to" errors={this.props.errors.city}>
                  <div>
                    <AutoCompleteInput
                      inputProps={inputProps}
                      onSelect={this.locationSelectHandler}
                      error={this.props.errors.city} className={css(style.textInput)} />
                  </div>
                </InputGroup>
                <InputGroup inputLabel="When" errors={this.props.errors.returning_dt}>
                  <DatePicker selected={this.state.leaving} minDate={moment()} id="leaving_dt" onChange={this.onLeaveSelected} className={css(style.textInput, style.inline)} placeholder="Departing Date" />
                  &nbsp; to &nbsp;
                  <DatePicker selected={this.state.returning} minDate={this.state.minReturningDate} id="returning_dt" onChange={this.onReturnSelected} className={css(style.textInput, style.inline)} placeholder="Departing Date" />
                </InputGroup>
                <InputGroup>
                  <Checkbox inline={true} value={this.state.flexible_dates} id="flexible_dates" onChange={this.onCheckboxChangeHandler} label="Dates are Flexible"/>
                </InputGroup>
                <InputGroup inputLabel="Who's paying">
                  <RadioButtonSet>
                    <RadioButton onChange={this.onWhosPayingSet} value={1} checked={this.state.who_pays === 1}>
                      I'll pay for us
                    </RadioButton>
                    <RadioButton onChange={this.onWhosPayingSet} value={2} type="radio" checked={this.state.who_pays === 2}>
                      You'll pay for us
                    </RadioButton>
                    <RadioButton onChange={this.onWhosPayingSet} value={3} type="radio" checked={this.state.who_pays === 3}>
                      Split the trip cost
                    </RadioButton>
                  </RadioButtonSet>
                </InputGroup>
                <InputGroup inputLabel="Description" errors={this.props.errors.description}>
                  <LongText rows={5} error={this.props.errors.description} value={this.state.description} onChange={this.onDescriptionSet} placeholder="Tell people more about your trip" />
                </InputGroup>
                <InputGroup inputLabel="Tags">
                  <TagsInput
                    items={this.props.tags}
                    onTagChange={this.onTagChange}
                  />
                </InputGroup>
                <InputGroup>
                  <div className="buttonset">
                    <ButtonSet>
                      <Button to="/trips" variant='simple'>Cancel</Button>
                      <Button variant="primary" type="submit">Create Trip</Button>
                    </ButtonSet>
                  </div>
                </InputGroup>
            </form>
          </Panel>
        </Container>
      </div>
    );
  }
}



export default TripCreate;


// WEBPACK FOOTER //
// ./src/components/pages/Trips/TripCreate.jsx